module.exports = __webpack_public_path__ + "img/gongyechuneng.252b075f.png";